import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalOverlayRef } from 'src/app/modal/modal-overlay-ref';

@Component({
    selector: 'gl-video-popup',
    templateUrl: './video-popup.component.html',
    styleUrls: ['./video-popup.component.scss'],
    standalone: false
})
export class VideoPopupComponent implements OnInit {
  public isPl = false;
  constructor(private modalRef: ModalOverlayRef, private translate: TranslateService) {
    this.modalRef.backgroundClicked();
  }

  public close() {
    this.modalRef.close();
  }

  ngOnInit(): void {
    this.isPl = this.translate.currentLang === 'pl';
  }
}
